import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/UserTask/UserTask.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UserTaskForm } from '../../../forms/UserTask/UserTaskForm';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { paths } from '../../RouterContainer';
import { useTranslation } from '../../../context/translationContext';
import { useEffect } from 'react';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component represents user tasks overview
 */
export const UserTaskCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { company } = useCurrentCompany();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  useEffect(() => {
    setBreadcrumbs([
      { path: paths.USER_TASKS, name: 'navigation.user-tasks' },
      {
        path: `${paths.USER_TASKS}/create`,
        name: 'navigation.user-tasks-create',
      },
    ]);
  }, []);

  /**
   * Handles create action for new user task
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    if (!company) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.USER_TASK_CREATE,
        data: { ...values, companyId: company.id },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(`/${paths.USER_TASKS}/edit/${response.data?.id}`);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.user-task.headline-create')}</h1>
      <UserTaskForm onSubmit={handleSubmit} />
    </div>
  );
};
